"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApChip = void 0;
var React = require("react");
var types_1 = require("../../utils/types");
var ApIcon_1 = require("../ApIcon");
var styles_1 = require("./styles");
exports.ApChip = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, icon = _a.icon, iconProps = _a.iconProps, small = _a.small, selected = _a.selected, props = __rest(_a, ["children", "className", "disabled", "icon", "iconProps", "small", "selected"]);
    return (React.createElement(styles_1.StyledChip, __assign({}, props, { disabled: disabled, className: "ap-chip " + (className ? className : ''), small: small, selected: selected }),
        React.createElement(styles_1.StyledChipLeftChild, null, icon && (React.createElement(ApIcon_1.ApIcon, __assign({ iconName: icon, iconSize: small ? 16 : 20 }, iconProps)))),
        React.createElement(styles_1.StyledChipRightChild, null, children)));
};
exports.ApChip.defaultProps = {
    disabled: false,
    theme: types_1.LIGHT
};
//# sourceMappingURL=ApChip.js.map